import React from 'react';
import { Lock, Zap, Star, ChevronDown } from 'lucide-react';
import { BookMockup } from './BookMockup';
import { PaymentLogos } from './PaymentLogos';
export function Hero() {
  return <section className="relative pt-8 pb-12 sm:pt-16 sm:pb-20 px-6 overflow-hidden bg-[#0a0a0a]" data-id="element-106">
      {/* Ambient background glows */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-[#d4a85a]/[0.04] rounded-full blur-[140px] pointer-events-none" data-id="element-107" />
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-[700px] h-[400px] bg-red-950/20 rounded-full blur-[140px] pointer-events-none" data-id="element-108" />

      <div className="max-w-2xl mx-auto w-full flex flex-col items-center text-center relative z-10" data-id="element-109">
        {/* === BLOCK 1 — Front-facing Book with prominent golden halo === */}
        <div className="relative flex items-center justify-center w-full mb-8 sm:mb-10" data-id="element-110">
          {/* Layered golden halos */}
          <div className="absolute w-[340px] h-[340px] sm:w-[560px] sm:h-[560px] bg-[#d4a85a]/[0.18] rounded-full blur-[80px] sm:blur-[120px] pointer-events-none" data-id="element-111" />
          <div className="absolute w-[260px] h-[260px] sm:w-[420px] sm:h-[420px] bg-amber-500/[0.14] rounded-full blur-[60px] sm:blur-[90px] pointer-events-none" data-id="element-112" />
          <div className="absolute w-[180px] h-[180px] sm:w-[280px] sm:h-[280px] bg-[#d4a85a]/[0.10] rounded-full blur-[40px] pointer-events-none" data-id="element-113" />

          <div className="relative z-10 w-full max-w-[260px] sm:max-w-[400px]" data-id="element-114">
            <BookMockup data-id="element-115" />
          </div>
        </div>

        {/* === BLOCK 2 — Flag bar + Eyebrow === */}
        <div className="h-[3px] w-20 bg-gradient-to-r from-yellow-500 via-blue-600 to-red-600 mb-4 sm:mb-5 rounded-full" data-id="element-116" />

        <p className="text-[#d4a85a] uppercase tracking-[0.2em] text-[11px] sm:text-xs font-semibold mb-4 sm:mb-6" data-id="element-117">
          THE BOOK THAT AWAKENS THE CONSCIENCE
        </p>

        {/* === BLOCK 3 — Title + Subtitle === */}
        <h1 className="font-serif text-5xl sm:text-7xl lg:text-[88px] text-[#e8e2d4] font-normal mb-4 sm:mb-6 leading-[0.95] tracking-tight" data-id="element-118">
          VENEZUELA
        </h1>

        <h2 className="font-serif italic text-[#d4a85a] text-2xl sm:text-4xl lg:text-[42px] leading-[1.15] mb-6 sm:mb-8 font-normal" data-id="element-119">
          The truth the world refused to see.
        </h2>

        {/* === BLOCK 4 — Intro paragraphs === */}
        <p className="text-gray-300 text-base sm:text-lg mb-4 leading-relaxed font-light max-w-xl mx-auto" data-id="element-120">
          Join thousands of readers worldwide who have decided to break the
          silence and discover the truth that the media buried.
        </p>

        <p className="italic text-[#d4a85a]/80 text-base sm:text-lg mb-8 sm:mb-10 leading-relaxed max-w-xl mx-auto font-light" data-id="element-121">
          An essential document to understand how a nation is destroyed from
          within—and a chronicle of justice that the world refused to see.
        </p>

        {/* === BLOCK 5 — Pricing Box === */}
        <div className="flex items-center justify-center gap-4 mb-5 sm:mb-6" data-id="element-122">
          <span className="text-xl sm:text-2xl text-gray-500 line-through font-light" data-id="element-123">
            $39.99
          </span>
          <span className="bg-[#DC2626] text-white text-[11px] font-bold tracking-wider px-2.5 py-1 rounded shadow-[0_0_10px_rgba(220,38,38,0.4)]" data-id="element-124">
            50% OFF
          </span>
          <span className="font-serif text-4xl sm:text-5xl text-[#d4a85a] font-bold leading-none drop-shadow-[0_0_15px_rgba(212,168,90,0.25)]" data-id="element-125"></span>
        </div>

        {/* === BLOCK 6 — CTA === */}
        <a href="https://templeofpages.com/cart/49184174768371:1" className="w-full sm:w-auto bg-[#DC2626] hover:bg-[#b91c1c] text-white font-bold py-4 sm:py-5 px-8 sm:px-12 rounded text-base sm:text-lg transition-all duration-300 shadow-[0_0_30px_rgba(220,38,38,0.3)] hover:shadow-[0_0_45px_rgba(220,38,38,0.5)] hover:-translate-y-1 tracking-wide uppercase text-center inline-block no-underline" data-id="element-126">
          Get 50% Off Today — $19.99
        </a>

        {/* === BLOCK 7 — Payment Icons === */}
        <PaymentLogos className="justify-center" data-id="element-127" />

        {/* === BLOCK 8 — Trust Lines === */}
        <div className="flex flex-col items-center gap-2 mt-6 text-xs sm:text-sm text-gray-500" data-id="element-128">
          <div className="flex items-center gap-2" data-id="element-129">
            <Lock className="w-4 h-4 text-gray-500" data-id="element-130" />
            <span data-id="element-131">256-bit SSL Encryption · Bank-Grade Security</span>
          </div>
          <div className="flex items-center gap-2" data-id="element-132">
            <Zap className="w-4 h-4 text-gray-500" data-id="element-133" />
            <span data-id="element-134">Instant delivery to your email after purchase</span>
          </div>
        </div>

        {/* === BLOCK 9 — Stars + Rating === */}
        <div className="flex items-center justify-center gap-3 mt-5 sm:mt-6 pt-5 sm:pt-6 border-t border-gray-800 w-full max-w-md" data-id="element-135">
          <div className="flex gap-1" data-id="element-136">
            {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-4 h-4 fill-[#d4a85a] text-[#d4a85a]" data-id="element-137" />)}
          </div>
          <span className="text-xs sm:text-sm text-gray-400" data-id="element-138">
            based on +16000 readers
          </span>
        </div>
      </div>

      {/* Pulsing amber chevron */}
      <div className="flex justify-center mt-8 sm:mt-12" data-id="element-139">
        <ChevronDown className="w-7 h-7 text-[#d4a85a]/70 animate-bounce" strokeWidth={1.5} data-id="element-140" />
      </div>
    </section>;
}